import { render, staticRenderFns } from "./addPlatformLabel.vue?vue&type=template&id=787f1e31&scoped=true"
import script from "./addPlatformLabel.vue?vue&type=script&lang=js"
export * from "./addPlatformLabel.vue?vue&type=script&lang=js"
import style0 from "./addPlatformLabel.vue?vue&type=style&index=0&id=787f1e31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787f1e31",
  null
  
)

export default component.exports